import styled from 'styled-components';

export const $LoaderContainer = styled.div`
  position: absolute;

  top: 0;
  height: 100%;
  width: 100%;
  right: 0;
  pointer-events: none;

  display: flex;
  justify-content: center;
  align-items: center;
`;

export const $ButtonChildContainer = styled.span<{
  $shouldShowLoading?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;

  color: ${({ $shouldShowLoading }) =>
    $shouldShowLoading ? 'transparent' : undefined};

  & svg {
    color: ${({ $shouldShowLoading }) =>
      $shouldShowLoading ? 'transparent' : undefined};
  }
`;
